import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface ThemeToggleButtonProps {
  className?: string;
  size?: 'sm' | 'md';
}

export const ThemeToggleButton: React.FC<ThemeToggleButtonProps> = ({
  className = '',
  size = 'md',
}) => {
  const { isDarkMode, toggleTheme } = useTheme();

  const sizeClasses = size === 'sm' ? 'h-5 w-5' : 'h-6 w-6';
  const buttonSize = size === 'sm' ? 'p-1.5' : 'p-2';

  return (
    <button
      type="button"
      className={`${buttonSize} rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 transition-colors ${className}`}
      aria-label="Toggle dark mode"
      title={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      onClick={toggleTheme}
    >
      {isDarkMode ? (
        <svg className={`${sizeClasses} text-yellow-400`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 3v1m0 16v1m8.66-13.66l-.71.71M4.05 19.95l-.71.71M21 12h-1M4 12H3m16.66 7.66l-.71-.71M4.05 4.05l-.71-.71M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
        </svg>
      ) : (
        <svg className={`${sizeClasses} text-gray-500 dark:text-gray-300`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M21 12.79A9 9 0 1111.21 3a7 7 0 109.79 9.79z" />
        </svg>
      )}
    </button>
  );
};
